import { useEffect } from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Zap, HeadphonesIcon, BadgeCheck, KeyRound, Star, SearchCheck } from "lucide-react";
import { useState } from "react";
import { api } from "../../lib/api";
import { useLanguage } from "../../contexts/LanguageContext";

export default function TrustStats() {
  const { t } = useLanguage();
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/reviews/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);

  const items = [
    { icon: ShieldCheck, title: t("trust.secure_payment", "Paiement sécurisé"), desc: t("trust.secure_payment_desc", "Mollie, carte bancaire, Apple Pay, Google Pay") },
    { icon: KeyRound, title: t("trust.no_password", "Aucun mot de passe demandé"), desc: t("trust.no_password_desc", "Uniquement votre nom d'utilisateur ou l'URL de votre profil") },
    { icon: Zap, title: t("trust.fast_delivery", "Livraison rapide"), desc: t("trust.fast_delivery_desc", "Livraison progressive sous 24 à 48 heures") },
    { icon: HeadphonesIcon, title: t("trust.support", "Support client dédié"), desc: t("trust.support_desc", "Une équipe disponible pour vous accompagner") },
    { icon: BadgeCheck, title: t("trust.guarantee", "Garantie de remplacement"), desc: t("trust.guarantee_desc", "Compensation automatique en cas de baisse constatée") },
    { icon: SearchCheck, title: t("trust.google_verified", "Vérifié par Google"), desc: t("trust.google_verified_desc", "Propriété du site validée sur Google Search Console") },
  ];
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8" data-testid="trust-section">
      <div className="mx-auto max-w-6xl">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-3">{t("home.trust_title", "Pourquoi choisir Buy Likes and Followers")}</h2>
          {stats && (
            <div className="inline-flex items-center gap-2 text-sm text-zinc-400" data-testid="trust-reviews-badge">
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />)}
              </div>
              <span>{stats.average_rating}/5 · {stats.count}+ {t("hero.trust_badge", "avis clients vérifiés")}</span>
            </div>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6">
          {items.map((it, i) => (
            <motion.div key={it.title} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="text-center px-2" data-testid={`trust-item-${i}`}>
              <div className="w-14 h-14 rounded-2xl bg-indigo-500/10 flex items-center justify-center mx-auto mb-4">
                <it.icon className="w-6 h-6 text-indigo-400" />
              </div>
              <h3 className="font-heading text-sm font-semibold text-white mb-1">{it.title}</h3>
              <p className="text-xs text-zinc-500">{it.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
